'use client';

import { useContext } from "react";
import { CustomAnchorContext } from "./CustomAnchor.context.js";
function CustomAnchor(props) {
  const renderAnchor = useContext(CustomAnchorContext);
  return renderAnchor(props);
}
export {
  CustomAnchor
};
